/* Carbon Objects — unified AJAX add-to-cart.
   One handler for the whole storefront. Binds to:
     - any <form data-co-add>  (home featured cards, collection cards)
     - <form class="co-add-form"> and the PDP form #coProductForm
   Adds via /cart/add, refreshes the Horizon cart drawer + cart icon via
   section rendering, dispatches the theme's real cart:update event, opens
   the drawer, and re-fires the legacy cart:updated/cart:refresh events used
   by the Shiprocket checkout-visibility toggle. Falls back to a native form
   POST on any error so add-to-cart still works if JS/fetch fails. */
(function () {
  if (window.__coCartBound) return;
  window.__coCartBound = true;

  function cartAddUrl() {
    return (window.Theme && Theme.routes && Theme.routes.cart_add_url)
      ? Theme.routes.cart_add_url
      : '/cart/add';
  }

  // Section ids the cart drawer renders, so /cart/add returns fresh HTML for them.
  function drawerSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var id = el.dataset && el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-co-add], form.co-add-form, #coProductForm');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    var fd = new FormData(form);
    var ids = drawerSectionIds();
    if (ids.length) fd.append('sections', ids.join(','));

    fetch(cartAddUrl(), {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (addRes) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (btn) { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); }

            // Open the cart drawer so the customer sees the result.
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer) drawer.setAttribute('auto-open', '');

            // Horizon's real cart event — re-renders drawer + cart icon count.
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'co-cart',
                data: {
                  source: 'co-cart',
                  itemCount: 1,
                  productId: form.dataset.productId,
                  sections: addRes.sections
                }
              }
            }));

            // Legacy events — Shiprocket checkout-visibility toggle listens to these.
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            if (btn) setTimeout(function () {
              btn.disabled = false;
              btn.textContent = original;
              btn.classList.remove('is-added');
            }, 1800);
          });
      })
      .catch(function () {
        // Network/parse error — let the browser do the real POST as a fallback.
        if (btn) { btn.disabled = false; btn.textContent = original; }
        form.submit();
      });
  });
})();
